import { Middleware } from 'redux';
import { isPlainObject, isString } from 'lodash-es';

const fullStoryIdentifyByOrgId: Middleware = _ => next => action => {
  try {
    const orgId: string | null =
      isPlainObject(action?.payload?.data) &&
      isString(action.payload.data.org_id) &&
      action.payload.data.org_id !== ''
        ? action.payload.data.org_id
        : null;
    if (orgId && window.FS?.setVars) {
      window.FS.setVars('page', { org_id: orgId });
    }
  } catch (err) {}
  return next(action);
};

export default fullStoryIdentifyByOrgId;
